module.exports = __webpack_public_path__ + "img/cmccLog1.39ebc894.jpg";